export function initCinematicParallax() {
    if (document.querySelector('.js-cinematic-parallax')) {
        import('./cinematic_parallax.js')
            .then(module => module.default())
            .catch(err => console.error("Errore Cinematic JS:", err));
    }
}
